import { render, staticRenderFns } from "./Jp.pug?vue&type=template&id=06bd3afe&scoped=true&lang=pug&"
import script from "./Jp.vue?vue&type=script&lang=js&"
export * from "./Jp.vue?vue&type=script&lang=js&"
import style0 from "./Jp.scss?vue&type=style&index=0&id=06bd3afe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bd3afe",
  null
  
)

export default component.exports